// Application-wide constants: route paths, colours, limits.

export const ROUTES = {
  home: '/',
  login: '/login',
  documents: {
    list: (typeCode: string) => `/documents/${typeCode}`,
    // Category-level "show all" view. Distinct path so a document type whose
    // TypeCode equals its Category (e.g. the canonical PAYMENT type) is never
    // mistaken for the category aggregate (task 252.1 collision).
    category: (categoryCode: string) => `/documents/category/${categoryCode}`,
    create: (typeCode: string) => `/documents/${typeCode}/new`,
    detail: (typeCode: string, id: string) => `/documents/${typeCode}/${id}`,
  },
  customers: {
    list: '/customers',
    detail: (id: string) => `/customers/${id}`,
  },
  fees: {
    plans: '/fees/plans',
    planDetail: (id: string) => `/fees/plans/${id}`,
    simulator: '/fees/simulator',
  },
  gl: {
    accounts: '/gl/accounts',
    balances: '/gl/balances',
    transactionTypes: '/gl/transaction-types',
    transaction: (id: string) => `/gl/transactions/${id}`,
  },
  workflows: {
    list: '/workflows',
    detail: (id: string) => `/workflows/${id}`,
  },
  assignments: {
    list: '/assignments',
  },
  tools: {
    balanceCalculation: '/tools/balance-calculation',
  },
  reference: '/reference',
  settings: '/settings',
  dashboard: '/',
} as const;

export const STATUS_COLORS: Record<string, string> = {
  DRAFT: 'gold',
  SUBMITTED: 'processing',
  UNDER_REVIEW: 'warning',
  APPROVED: 'success',
  REJECTED: 'error',
  CANCELLED: 'default',
  ACTIVE: 'success',
  COMPLETED: 'success',
};

export const PAGE_SIZE_DEFAULT = 20;
export const PAGE_SIZE_OPTIONS = [10, 20, 50, 100];
